import React, { useContext, useEffect} from 'react';
import { useMarine } from '../../../../hooks/useMarine'
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css'

const MarineList = () => {

  const { marineService } = useMarine(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
     marineService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    marineService.setFilter({
      ...marineService.filter,
      [name]: value
    });
  };
 

  return <div>

    <div className={ cl.headMain }> 
        <h1>საზღვაო ხაზი</h1>   
        <Add marineService={marineService} /> 
    </div>


    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
              <th className={cl.id}>#</th>
              <th className={ cl.pad0 }>
                  <input name="name"  placeholder="დასახელება" value={marineService.filter.name} onChange={handleInputChange} /> 
              </th>
              <th>მობილური</th> 
              <th>მისამართი</th> 
              <th>მისამართი 2</th> 
              <th>კოდი</th> 
              <th>ქვეყანა</th> 
              <th>რეგიონი</th> 
              <th>ქალაქი</th> 
              <th> </th> 
              </tr>
          </thead>
          <tbody>
              {marineService.items.map((item) =>
                  <tr key={item.id}>
                  <td className={cl.id}>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.mobile}</td>
                  <td>{item.address}</td>
                  <td>{item.address2}</td>
                  <td>{item.code}</td>
                  <td>{item.country}</td>
                  <td>{item.district}</td>
                  <td>{item.city}</td>
                  <td className={ cl.btntbl }>
                      <div className={ cl.btns }>
                        <Edit marineService={marineService} defaultMarine={item}/>
                        <Delete marineService={marineService} defaultMarine={item}/> 
                      </div>
                  </td>
                  </tr>  
              )}
          </tbody>
      </table>

    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={marineService.total} 
                perPage={marineService.filter.limit} 
                current={marineService.filter.page} 
                paginate={(page) => {
                    marineService.setFilter({
                    ...marineService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                    marineService.setFilter({
                    ...marineService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default MarineList;